import { Box, Button, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Order } from "../../../Shared/GeneratedTypes";
import { Localizations } from "../../../Shared/sharedTypes";
import { enqueueSnackbar } from "../../../Shared/Redux/Actions/notificationActions";
import { ApplicationData } from "../../types";

const mapState = function (state: ApplicationData) {
    return {};
};

const mapDispatch = {
    enqueueSnackbar,
};

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {
    quickCode: string;
    order: Order;
    localizations: Localizations;
};

function IOS({ quickCode, order, localizations, enqueueSnackbar }: PropTypes) {
    let linkRef = useRef<HTMLTextAreaElement | null>(null);

    useEffect(() => {
        copyToClipboard();
    }, [linkRef]);

    function copyToClipboard(e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        if (linkRef.current) {
            linkRef.current.select();
            try {
                document.execCommand("copy");
                if (e) {
                    enqueueSnackbar({ message: localizations.copiedToClipboard, options: { variant: "success" } });
                }
            } catch {}
        }
    }

    return (
        <Grid
            item
            zeroMinWidth
            className="transparentBackground"
            style={{
                flex: 1,
                paddingTop: 50,
            }}
        >
            <Box textAlign="center">
                <img
                    src={order.logoPhotoUrl}
                    alt="Carrier Logo"
                    style={{
                        marginTop: 10,
                        marginBottom: 10,
                        height: "100px",
                        filter: "drop-shadow(rgba(200, 200, 200, 0.5) 3px 2px 11px)",
                    }}
                />
            </Box>
            <Box
                m={2}
                p={2}
                style={{
                    borderRadius: 20,
                    background: "#000000CC",
                    color: "#fff",
                }}
            >
                <Typography variant="subtitle1" style={{ textAlign: "center" }}>
                    {localizations.appleBrowserDetected}
                </Typography>
            </Box>
            <textarea
                ref={linkRef}
                style={{
                    display: "block",
                    width: "90%",
                    padding: 6,
                    textAlign: "center",
                    borderRadius: 8,
                    margin: "auto",
                    backgroundColor: "rgba(100, 100, 100, 0.5)",
                }}
                rows={2}
                value={window.location.origin + "/GuideStream/" + quickCode}
            ></textarea>
            <Box m={2} textAlign="center">
                <Button variant="contained" color="primary" onClick={copyToClipboard}>
                    {localizations.appleCopyToClipboard}
                </Button>
            </Box>
            <Box textAlign="center" marginTop={1}>
                {localizations.PoweredBy} <br />
                <img
                    src="/images/GuideStreamLogo.png"
                    alt="Powered by Guide Stream 360"
                    style={{
                        objectFit: "scale-down",
                        marginTop: 5,
                        marginBottom: 0,
                        maxWidth: "70%",
                        filter: "drop-shadow(rgba(0, 0, 0, 0.5) 3px 2px 11px)",
                    }}
                />
            </Box>
        </Grid>
    );
}

export default connector(IOS);
